module.exports = {"permission":{"view_external":"External Devices","manage_external":"Manage External Devices"}};